// extracted by mini-css-extract-plugin
export default {"root":"ParallaxBlock_root__u2RpI","wrapper":"ParallaxBlock_wrapper__LTmM5","background":"ParallaxBlock_background__RfYQd","content":"ParallaxBlock_content__rA+d7"};